
import SearchResult from "@/components/search/v2/SearchResult"
import jobListService from "@/services/lists.service.js"
import {
    defineComponent,
    useRoute,
    useContext,
    useAsync,
    useFetch,
    ref,
} from "@nuxtjs/composition-api"
import { Search } from "@/models/search"
import ShareSpeedModal from "@/components/base/ShareSpeedModal.vue"
import { mdiChevronLeft } from "@mdi/js"
import Button from "@/components/base/Button.vue"
import { mapGetters } from "vuex"

export default defineComponent({
    name: "JobListPage",
    components: { Button, ShareSpeedModal, SearchResult },
    layout: "modern",
    data: () => ({
        mdiChevronLeft,
    }),
    setup() {
        const route = useRoute()
        let location = undefined
        if (route.value?.query?.location) {
            location = JSON.parse(route.value.query.location)
        }
        const search = ref(
            new Search({
                type: "apprenticeship",
                distance: 5000,
                list: route.value.params.jobListSlug,
                location,
            })
        )
        const { error } = useContext()
        const jobList = useAsync(async () => {
            try {
                return await jobListService.getJobList(
                    route.value.params.jobListSlug
                )
            } catch (e) {
                error({
                    statusCode: 404,
                    message: "Die Liste wurde nicht gefunden.",
                })
            }
        })
        useFetch(async () => {
            if (search.value.data.length > 0) return
            await search.value.execute()
        })
        return { search, jobList }
    },
    computed: {
        ...mapGetters("routing", ["previousRoute"]),
        customItems() {
            if (this.$fetchState.pending) return []
            return [
                {
                    id: `inline-card-0`, // Used as v-for-key
                    slug: `inline-card-0`, // Used for oabalytics
                    component: () => import("@/components/trainee/AskNikoCard"),
                },
            ]
        },
        shareUrl() {
            if (!this.jobList) return
            return this.$oabalytics.campaignUrl(
                this.$config.baseURL + this.$route.fullPath,
                {
                    source: "share",
                    campaignId: "auswahl_" + this.jobList.id,
                }
            )
        },
        backgroundSrc() {
            if (!this.jobList) return
            return this.$getImage({
                image: this.jobList.image,
                preferedSize: 1,
            }).src
        },
        backgroundStyles() {
            if (!this.jobList) return
            return {
                backgroundImage: `url(${this.backgroundSrc})`,
            }
        },
    },
    methods: {
        goBack() {
            if (this.previousRoute) {
                this.$store.dispatch("routing/back")
                this.loadingBack = false
                return
            } else {
                this.$router.push({ name: "index" })
            }
        },
    },
    head() {
        return {
            title: this.jobList?.title,
            link: [
                {
                    hid: "rel:canonical",
                    rel: "canonical",
                    href: this.$config.baseURL + this.$route?.path,
                },
            ],
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.jobList?.description,
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content: this.jobList?.title,
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content: this.jobList?.description,
                },
                {
                    hid: "og:image",
                    name: "og:image",
                    content: this.backgroundSrc,
                },
                {
                    hid: "og:image:type",
                    name: "og:image:type",
                    content: "image/jpeg",
                },
            ],
        }
    },
})
